const FuelIcon = ({ color = '#000', width = 24 }) => {
    return (
        <svg 
            xmlns="http://www.w3.org/2000/svg" 
            version="1.1" 
            viewBox="0 0 800 800" 
            width={width} 
            height={width} 
            style={{ verticalAlign: 'middle' }}
        >
            <g id="Layer_1">
                <path 
                    fill={color}
                    d="M772.4,155.3l-100-50c-24.8-12.4-54.8-2.3-67.1,22.4-12.4,24.7-2.3,54.7,22.4,67.1l72.4,36.2v344.1c0,13.8-11.2,25-25,25s-25-11.2-25-25v-200c0-82.7-67.3-150-150-150v-125c0-55.1-44.8-100-100-100h-250C94.8,0,50,44.9,50,100v554.3l-35.4,35.4c-9.4,9.4-14.6,22.1-14.6,35.4v25c0,27.6,22.4,50,50,50h450c27.6,0,50-22.4,50-50v-25c0-13.3-5.3-26-14.6-35.4l-35.4-35.4v-329.3c27.6,0,50,22.4,50,50v200c0,68.9,56.1,125,125,125s125-56.1,125-125V200c0-18.9-10.7-36.3-27.6-44.7ZM425,350h-133.1l-43.7-109.3c-5.1-12.8-19.8-19-32.5-13.9-12.8,5.1-19.1,19.7-13.9,32.5l36.3,90.7h-113.1V100c0-13.8,11.2-25,25-25h250c13.8,0,25,11.2,25,25v250Z"
                />
                <circle fill={color} cx="275" cy="150" r="25"/>
                <circle fill={color} cx="375" cy="175" r="25"/>
                <circle fill={color} cx="175" cy="175" r="25"/>
            </g>
        </svg>
    );
};

export default FuelIcon;
